module.exports = __webpack_public_path__ + "static/media/pakhuri_end.fec2efb4.png";